import { PatientsModel } from 'features/shared/types/userType'
import { useMutation } from 'react-query'
import { getListPatients } from './patient.service'


export function useGetListPatients() {
  return useMutation((page: number) => getListPatients(page));
}
